import React from 'react'
import {FC} from 'react'
import {Col, Input, Radio, Row} from 'antd'
import {STANDARD_ITEM_RULES} from '../../../../../common/constants'
import Form from 'antd/lib/form'
import FormEntityInterface from '../../../../common/models/form-entity-interface'
import isAdultValidator from '../../../../../../common/helpers/validators/is-adult'
import Date from '../../../../../../common/components/custom-form-components/date'
import IDS from '../../../constants/ids'
import PhoneItem from '../../../../../../common/components/form-items/phone-item'

const {Item} = Form

interface IndividualEntrepreneurProps extends FormEntityInterface {}

const IndividualEntrepreneur: FC<IndividualEntrepreneurProps> = ({path = []}) => {
    return (
        <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'inn']} label={'ИНН'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'contactName']} label={'ФИО'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'birthday']} label={'Дата рождения'} rules={[
                    {required: true, message: 'Введите данные'},
                    {validator: isAdultValidator}
                ]}>
                    <Date/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'gender']} label={'Пол'} rules={STANDARD_ITEM_RULES}>
                    <Radio.Group>
                        <Radio.Button value="Мужской">Мужской</Radio.Button>
                        <Radio.Button value="Женский">Женский</Radio.Button>
                    </Radio.Group>
                </Item>
            </Col>
            <Col span={24}>
                <Item name={[...path, 'address']} label={'Адрес регистрации'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'passportSeries']} label={'Серия паспорта'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'passportNumber']} label={'Номер паспорта'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'email']} label={'Электронная почта'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <PhoneItem name={[...path, IDS.CONTACT_PHONE]}/>
            </Col>
        </Row>
    )
}

export default IndividualEntrepreneur